import { createContext, useContext } from 'react';

type MyLearningTabContextType = {
  /**
   * The active tab's query-param value. `undefined` only in dynamic-default mode
   * while the data-driven default is still being resolved (see `MyLearningTabProvider`).
   */
  currentTab?: string;
  /** User-initiated tab change — pushes a new history entry. */
  onTabChange: (value: string) => void;
};

const MyLearningTabContext = createContext<MyLearningTabContextType | undefined>(undefined);

/**
 * @description Used to get the current my learning tab and the function to change the tab
 * @returns {currentTab, onTabChange}
 */
export const useCurrentMyLearningTab = () => {
  const context = useContext(MyLearningTabContext);

  return { currentTab: context?.currentTab, onTabChange: context?.onTabChange };
};

export default MyLearningTabContext;
